import React from "react";
import Avatar from "../../avatar";

const ReservationItemSmall = ({
	name,
    photoUrl,
    club,
    date,
    extra = "",
	photoSize = "thumb6",
}: {
    name: string;
    photoUrl: string;
    club: string;
    date: string;
    extra?: string;
    photoSize?: string;
}) => (
    <div className={`item reservation small ${extra}`}>
        <div className="header">
            <Avatar photoUrl={photoUrl} size={photoSize} />
            <div className="name">{name}</div>
        </div>
        <div className="body">
            <div className="title">
                <div className="longTextWrap">
                    <div className="longText">{club}</div>
                </div>
            </div>
            <div className="meta">
                <div className="longTextWrap">
                    <div className="longText">{date}</div>
                </div>
            </div>
        </div>
    </div>
);

export default ReservationItemSmall;
